import { actionTypes } from '../actions/idx_admin_team_assignment.ac'

const initialState = {
  error: null,
  teamAssignment: null,
  isFetching: false
}

export const idxAdminTeamAssignment = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCHING_IDX_ADMIN_TEAM_ASSIGNMENT:
      return {
        ...state,
        isFetching: true
      }

    case actionTypes.RECEIVED_IDX_ADMIN_TEAM_ASSIGNMENT:
      return {
        ...state,
        error: null,
        isFetching: false,
        teamAssignment: action.data
      }

    case actionTypes.SET_IDX_ADMIN_TEAM_ASSIGNMENT:
      return {
        ...state,
        teamAssignment: action.data
      }

    case actionTypes.FAILED_FETCHING_IDX_ADMIN_TEAM_ASSIGNMENT:
      return {
        ...state,
        error: true,
        teamAssignment: null,
        isFetching: false
      }

    default:
      return state
  }
}
